// extracted by css-extract-rspack-plugin
module.exports =  {"template22":"Template22-VwOd__template22","tooltip-outer":"Template22-q6f3__tooltip-outer","tooltip":"Template22-SFts__tooltip"};